import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import { NewsItem } from '../../types';

const NewsCard: React.FC<{ news: NewsItem }> = ({ news }) => {
    const theme = useTheme();
    const dark = theme.palette.mode === 'dark';
    const date = new Date(news.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    return (
        <Card sx={{ '&:hover': { transform: 'translateY(-4px)' }, transition: 'all 0.3s' }}>
            <CardActionArea component={RouterLink} to={`/news/${news.id}`}>
                <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
                    <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ mb: 2 }}>
                        {news.tags.map(t => (
                            <Chip key={t} label={t} size="small" sx={{ height: 24, fontSize: '0.7rem', fontWeight: 600, bgcolor: dark ? 'rgba(96,165,250,0.1)' : 'rgba(37,99,235,0.06)', color: dark ? '#93C5FD' : '#2563EB' }} />
                        ))}
                    </Stack>
                    <Typography variant="h5" sx={{ fontWeight: 700, fontSize: { xs: '1.15rem', md: '1.3rem' }, mb: 1.5, lineHeight: 1.3, color: 'text.primary' }}>{news.title}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, lineHeight: 1.7, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{news.excerpt}</Typography>
                    <Stack direction="row" spacing={2.5} sx={{ pt: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <CalendarMonthRoundedIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
                            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>{date}</Typography>
                        </Stack>
                    </Stack>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default NewsCard;
